import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTableContainer-root': {
      overflowX: 'hidden',
    },
    '& .div': {
      padding: '1rem',
      display: 'block',
      overflow: 'auto',
    },
    '& .table': {
      borderSpacing: '0',
    },
    '& .thead': {
      border: `1px solid ${theme.palette.grey[300]}`,
      background: theme.palette.grey[100],
      overflowY: 'auto',
      overflowX: 'hidden',
      fontWeight: '500',
      lineHeight: '1.5rem',
    },
    '& .tbody': {
      border: `1px solid ${theme.palette.grey[300]}`,
      borderTop: '0px',
      overflowX: 'hidden',
    },
    '& .tr': {
      display: 'flex',
      flex: '0 1 auto',
      minWidth: '100px',
      borderTop: `1px solid ${theme.palette.grey[100]}`,
    },
    '& tr:hover': {
      background: theme.palette.grey[50],
    },
    '& .containerRow': {
      display: 'flex',
      flexDirection: 'column',
    },
    '& .alignCenter': {
      display: 'flex',
      justifyContent: 'center',
    },
    '& .detailsDropDown': {
      border: `1px solid ${theme.palette.grey[300]}`,
      padding: theme.spacing(2),
      background: theme.palette.grey[100],
      flexGrow: 1,
      overflow: 'hidden',
    },
    '& .th, .td': {
      display: 'inline',
      margin: '0',
      position: 'relative',
    },
    '& .td': {
      width: 'inherit',
      padding: '0.4rem',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textAlign: 'center',
    },
    '& .headCell': {
      padding: theme.spacing(2),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& .headerText': {
        display: 'inline',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
      },
    },
    '& .MuiTableSortLabel-icon': {
      opacity: '0.3',
      margin: '0',
    },
    '& .resizer': {
      right: '0',
      width: '10px',
      height: '70%',
      position: 'absolute',
      zIndex: '1',
      touchAction: 'none',
      borderRight: `1px solid ${theme.palette.grey[300]}`,

      '&:hover': {
        borderRight: `4px double ${theme.palette.grey[400]}`,
      },
      '& .isResizing': {
        background: 'red',
      },
    },
    '& .MuiTableSortLabel-active': {
      color: theme.palette.grey[900],
    },
  },
  noData: {
    color: theme.palette.grey[500],
    marginBottom: 100,
  },
  spinnerHolder: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderTop: '0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
  },
  noDataContainer: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderTop: '0px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default useStyles;
